import React, { useEffect } from 'react';
import { Menu } from 'antd';
import share from 'assets/images/pages/community/share.webp';
import shareKakaotalk from 'assets/images/pages/community/shareKakaotalk.webp';
import sharelink from 'assets/images/pages/community/sharelink.webp';

type TShareLinkMenuProps = {
  title?: string;
  description?: string;
  imageUrl?: string;
  pageUrl: string;
  btnTitle?: string;
};

const ShareLinkMenu = ({ title, description, imageUrl, pageUrl, btnTitle }: TShareLinkMenuProps) => {
  const shareKakao = () => {
    const { Kakao } = window as any;

    Kakao.Link.sendDefault({
      objectType: 'feed',
      content: {
        title: title, //필수
        description: description,
        imageUrl: imageUrl, //필수
        link: {
          //필수
          mobileWebUrl: pageUrl,
          webUrl: pageUrl,
        },
      },

      buttons: [
        {
          title: btnTitle,
          link: {
            mobileWebUrl: pageUrl,
            webUrl: pageUrl,
          },
        },
      ],
    });
  };

  useEffect(() => {
    const { Kakao } = window as any;
    if (!Kakao.isInitialized()) {
      Kakao.init('cda75f3cd4112396004aca5d7da58bc8');
    }
  }, []);

  return (
    <div>
      <Menu className='share-link-menu-container' mode='horizontal' triggerSubMenuAction='click'>
        <Menu.SubMenu
          popupClassName={'share-link-menu'}
          icon={<img src={share} alt='shareBtn' />}
          // title={<img src={share} alt='shareBtn' />}
        >
          <Menu.Item onClick={shareKakao}>
            <img src={shareKakaotalk} alt='shareBtn' /> {'  '}카카오톡으로 공유하기
          </Menu.Item>
          <Menu.Item onClick={() => navigator.clipboard.writeText(window.location.href)}>
            <img src={sharelink} alt='shareBtn' /> {'  '}URL 복사하기
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
    </div>
  );
};

export default ShareLinkMenu;
